module.exports = __webpack_public_path__ + "static/media/bts_veld_170806_009_small.08330466.jpg";